<crownx-icon-button
	Id="userMenuToggle"
	[MatMenuTriggerFor]="userMenu"
	AriaLabel="User menu"
>
	person
</crownx-icon-button>
<mat-menu #userMenu="matMenu">
	<button *ngIf="IsSwitchVisible" mat-menu-item (click)="OnSwitchClick()" id="user-menu-item-switch">
		<mat-icon>swap_horiz</mat-icon>
		<span>Switch</span>
	</button>
	<button mat-menu-item (click)="OnLogoutClick()" id="logout">
		<mat-icon>logout</mat-icon>
		<span>Logout</span>
	</button>
</mat-menu>